export const COUNTRIES = {
  ZW: { name: "Zimbabwe", flag: "🇿🇼" },
  ZA: { name: "South Africa", flag: "🇿🇦" },
  NG: { name: "Nigeria", flag: "🇳🇬" },
  GH: { name: "Ghana", flag: "🇬🇭" },
  KE: { name: "Kenya", flag: "🇰🇪" },
  ZM: { name: "Zambia", flag: "🇿🇲" },
  MW: { name: "Malawi", flag: "🇲🇼" },
  BW: { name: "Botswana", flag: "🇧🇼" },
  NA: { name: "Namibia", flag: "🇳🇦" },
  TZ: { name: "Tanzania", flag: "🇹🇿" },
  UG: { name: "Uganda", flag: "🇺🇬" },
  CM: { name: "Cameroon", flag: "🇨🇲" },
  CD: { name: "DRC", flag: "🇨🇩" },
  AD: { name: "African Diaspora", flag: "🌍" },
};

export const COUNTRY_LIST = Object.entries(COUNTRIES).map(([code, v]) => ({ code, ...v }));

export const LANGUAGES = [
  "isiNdebele", "isiZulu", "Shona", "English", "Setswana", "Sesotho",
  "Swahili", "Yoruba", "Igbo", "French", "Portuguese",
];

export const CONTENT_TYPES = [
  "FEATURE_FILM", "SHORT_FILM", "SERIES", "DOCUMENTARY", "TALK_SHOW",
  "MUSIC_VIDEO", "COMEDY", "CREATOR_CONTENT", "AFRICAN_DIASPORA_CONTENT",
];

export const typeLabel = (t) =>
  (t || "").replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

export const FALLBACK_POSTER =
  "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

export const onImgError = (e) => {
  if (e.currentTarget.src !== FALLBACK_POSTER) e.currentTarget.src = FALLBACK_POSTER;
};

export const countryFlag = (code) => COUNTRIES[code]?.flag || "🌍";
export const countryName = (code) => COUNTRIES[code]?.name || code;

export const formatDuration = (seconds) => {
  if (!seconds) return "—";
  const h = Math.floor(seconds / 3600);
  const m = Math.round((seconds % 3600) / 60);
  return h ? `${h}h ${m}m` : `${m}m`;
};

export const ROLE_LABELS = {
  ADMIN: "Admin",
  CREATOR: "Creator",
  SUBSCRIBER: "Premium",
  FREE_USER: "Free",
};
